module.exports = __webpack_public_path__ + "img/ic_contentitem_play.e3d3bd87.svg";